import {useEffect} from "react";
import {shallowEqual} from "react-redux";

import {getPropertyDetailApi} from "../../property/api/get_property_detail";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {useAppDispatch, useAppSelector} from "../../store/hooks";

const selectPropertyDetail = (propertyId: number) => getPropertyDetailApi.endpoints.getPropertyDetail.select(propertyId);

export const useRegistrationSentApplicationsProperties = (propertyIds: number[]) => {
    const dispatch = useAppDispatch();
    const propertyIdsKey = propertyIds.join(",");

    useEffect(() => {
        const subscriptions = propertyIds.map((propertyId) => dispatch(getPropertyDetailApi.endpoints.getPropertyDetail.initiate(propertyId)));

        return () => subscriptions.forEach((subscription) => subscription.unsubscribe());
    }, [propertyIdsKey]);

    const propertyDetails = useAppSelector((state) => propertyIds.map((propertyId) => selectPropertyDetail(propertyId)(state).data), shallowEqual);
    const isLoading = useAppSelector((state) =>
        propertyIds.some((propertyId) => {
            const {isSuccess, isError} = selectPropertyDetail(propertyId)(state);

            return !isSuccess && !isError;
        })
    );

    return {
        isLoading,
        properties: propertyDetails.filter((property): property is IPropertyDetail => Boolean(property))
    };
};
import {useEffect} from "react";
import {shallowEqual} from "react-redux";

import {getPropertyDetailApi} from "../../property/api/get_property_detail";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {useAppDispatch, useAppSelector} from "../../store/hooks";

const selectPropertyDetail = (propertyId: number) => getPropertyDetailApi.endpoints.getPropertyDetail.select(propertyId);

export const useRegistrationSentApplicationsProperties = (propertyIds: number[]) => {
    const dispatch = useAppDispatch();
    const propertyIdsKey = propertyIds.join(",");

    useEffect(() => {
        const subscriptions = propertyIds.map((propertyId) => dispatch(getPropertyDetailApi.endpoints.getPropertyDetail.initiate(propertyId)));

        return () => subscriptions.forEach((subscription) => subscription.unsubscribe());
    }, [propertyIdsKey]);

    const propertyDetails = useAppSelector((state) => propertyIds.map((propertyId) => selectPropertyDetail(propertyId)(state).data), shallowEqual);
    const isLoading = useAppSelector((state) =>
        propertyIds.some((propertyId) => {
            const {isSuccess, isError} = selectPropertyDetail(propertyId)(state);

            return !isSuccess && !isError;
        })
    );

    return {
        isLoading,
        properties: propertyDetails.filter((property): property is IPropertyDetail => Boolean(property))
    };
};
